import { IClassroomResource } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { UserRole } from "../../users";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { AnnouncementStatus, IAnnouncementResource } from "../types";

export type IAnnouncementUpdateMutationParameters = {
    announcement: RelationalValue<IAnnouncementResource>;
    data: {
        language?: RelationalValue<ILanguageResource>;
        title?: string;
        body?: string;
        appearanceDate?: string;
        videoUrl?: string | null;
        targetRoles?: UserRole[];
        targetClassrooms?: RelationalValue<IClassroomResource>[];
        status?: AnnouncementStatus;
    };
};

export type IAnnouncementUpdateMutationResult = IAnnouncementResource;

export const announcementUpdateMutation: IApiMutationFunction<IAnnouncementUpdateMutationParameters> = ({
    announcement,
    data,
}) => ({
    method: "PUT",
    url: `/announcements/${mapRelationalValue(announcement)}`,
    data: {
        ...data,
        ...(data.language !== undefined
            ? { language: mapRelationalValueAsIRI(EntityTypes.LANGUAGE, data.language) }
            : {}),
        ...(data.targetClassrooms !== undefined
            ? {
                  targetClassrooms: data.targetClassrooms.map(classroom =>
                      mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom),
                  ),
              }
            : {}),
    },
});

export const useAnnouncementUpdateMutation = createApiMutationHook<
    IAnnouncementUpdateMutationParameters,
    IAnnouncementUpdateMutationResult
>(announcementUpdateMutation);
